// Hook to get previous props or state.
// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state

import { useEffect, useRef } from 'react';

const usePrevious = <T extends unknown>(value: T): T | undefined => {
	const ref = useRef<T | undefined>(undefined);
	useEffect(() => {
		ref.current = value;
	});

	return ref.current;
};

export default usePrevious;
